// extracted by mini-css-extract-plugin
module.exports = {"root":"DocumentTenantBtn_root__17cXh"};